import { render, staticRenderFns } from "./ScreenHomeRecepcao.vue?vue&type=template&id=163a2732&lang=true&"
import script from "./ScreenHomeRecepcao.vue?vue&type=script&lang=js&"
export * from "./ScreenHomeRecepcao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports